(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || (window.Shopify && Shopify.designMode)) return;

  var lenis = new Lenis({
    lerp: 0.1,
    duration: 1.2,
    smoothWheel: true,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    var revealTargets = document.querySelectorAll(
      '.card-wrapper, .collection-list__item, .banner__content, .rich-text__blocks > *, .multicolumn-card, .collage__item, [data-motion-reveal]'
    );
    revealTargets.forEach(function (el) {
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 24 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            once: true,
          },
        }
      );
    });

    var hoverTargets = document.querySelectorAll(
      '.button, .product-form__submit, .slider-button'
    );
    hoverTargets.forEach(function (el) {
      var scaleTo = gsap.quickTo(el, 'scale', { duration: 0.3, ease: 'power2.out' });
      el.addEventListener('mouseenter', function () {
        scaleTo(1.035);
      });
      el.addEventListener('mouseleave', function () {
        scaleTo(1);
      });
    });
  }
})();
